<template>
  <div class="font-nunito text-base text-black dark:text-white dark:bg-slate-900 _mt-[74px] overflow-hidden">
    <nav-bar-component />
    <div class="h-60 text-bold">QrLink</div>
    <!-- <slide-hero-component2 /> -->
    <!-- <product-card-component /> -->
    <!--   <about-company-component /> -->

   

    <div class="w-5/6 md:w-3/4 mx-auto text-center mt-20 mb-5">
      <div class="relative w-full bg-white shadow-md py-3 px-6 flex items-center justify-between border-b border-blue-300 mb-3">
        <h1 class="text-2xl font-semibold text-gray-800 mx-auto">Fiche Produit Electro Survey</h1>
        <div class="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-blue-500 rounded-full"></div>
      </div>
      <div class="py-3 dark:border-darkmode-400">
        <!-- <h2 class="text-2xl font-bold title">Electro Survey</h2> -->
        <p class="text-justify text-xl font-bold">L'Electro Survey est un kit électronique novateur conçu pour collecter efficacement les retours des clients. Avec sa conception conviviale et ses caractéristiques avancées, il constitue un atout précieux pour améliorer l'expérience client.</p>
      </div>
    </div>

    <div class="perso mt-5">
      <div class="rounded-lg shadow hover:shadow-md imgDiv p-3 border-red-500 h-fit">
        <img src="../assets/images/bsdKit/Porte-menu-bsd.webp" alt="" />
      </div>
      <div class="description w-full lg:w-1/2">
        <!-- BEGIN: Projects -->
        <div class="intro-y box col-span-12 2xl:col-span-6">
          <div class="px-5">
            <div class="box box--list">
              <header class="box--list__header">
                <h1 class="box--list__header-title w-auto mx-auto">Fonctionnalité clés :</h1>
              </header>

              <div class="box--list__items">
                <div class="box--list__item">
                  <h2 class="box--list__title">Emoticônes Intuitives :</h2>
                  <p class="box--list__description text-justify font-bold">L'Electro Survey est équipé de trois émoticônes (bon, passable, mauvais) qui permettent aux clients de donner rapidement leur avis sur une expérience.</p>
                </div>

                <div class="box--list__item">
                  <h2 class="box--list__title">Question Imprimée :</h2>
                  <div class="box--list__description text-justify font-bold">Une question personnalisée est imprimée sur un module qui accompagne l'appareil. Les clients répondent en sélectionnant l'émoticône appropriée.</div>
                </div>

                <div class="box--list__item">
                  <h2 class="box--list__title">Autonomie Exceptionnelle :</h2>
                  <div class="box--list__description text-justify font-bold">Grâce à sa batterie longue durée, l'Electro Survey fonctionne pendant plus de trois mois, offrant une collecte de données ininterrompue.</div>
                </div>
                <div class="box--list__item">
                  <h2 class="box--list__title">Facilité d'Installation :</h2>
                  <div class="box--list__description text-justify font-bold">L'appareil est simple à installer dans divers environnements, y compris les points de vente, les bureaux, et les lieux d'accueil.</div>
                </div>
                <div class="box--list__item">
                  <h2 class="box--list__title">Tableau de Bord :</h2>
                  <div class="box--list__description text-justify font-bold">Les entreprises ont accès à un tableau de bord complet qui leur permet de suivre les données en temps réel, d'analyser les résultats et d'identifier les tendances.</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Bouton avec icône -->
          <div class="w-full text-center">
            <button v-if="!isOpen" @click="isOpen = !isOpen" class="p-2">
              <i class="uil text-3xl transition-transform duration-300" :class="isOpen ? 'uil-angle-up' : 'uil-angle-down'"></i>
            </button>
          </div>

          <div :class="isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-95'" v-if="isOpen" class="px-5 transition-all duration-300">
            <div class="box box--list">
              <header class="box--list__header">
                <h1 class="box--list__header-title w-auto mx-auto">Avantages :</h1>
              </header>

              <div class="box--list__items">
                <div class="box--list__item">
                  <h2 class="box--list__title">Collecte de Données en Temps Réel</h2>
                  <p class="box--list__description text-justify font-bold">Les entreprises peuvent recueillir des avis instantanés de manière discrète et non intrusive.</p>
                </div>

                <div class="box--list__item">
                  <h2 class="box--list__title">Amélioration de la Satisfaction Client :</h2>
                  <div class="box--list__description text-justify font-bold">L'Electro Survey permet d'identifier les domaines à améliorer, ce qui améliore la satisfaction globale de la clientèle.</div>
                </div>

                <div class="box--list__item">
                  <h2 class="box--list__title">Analyse Fine des Données :</h2>
                  <div class="box--list__description text-justify font-bold">Les retours des clients sont regroupés pour fournir des informations précieuses sur les tendances et les points faibles.</div>
                </div>
              </div>
            </div>
          </div>

          <div class="w-full text-center">
            <button v-if="isOpen" @click="isOpen = !isOpen" class="p-2 text-center">
              <i class="uil text-3xl transition-transform duration-300" :class="isOpen ? 'uil-angle-up' : 'uil-angle-down'"></i>
            </button>
          </div>
        </div>
        <!-- END: Projects -->
      </div>
    </div>

    <grille-hosting-comptoir />
    <video-play-component class="mb-10" />

    <footer-component class="absolute bottom-0" />
    <back-to-top-component />
  </div>
</template>

<script>
// @ is an alias to /src
// import { UisStar } from "@iconscout/vue-unicons-solid";
// import SlideHeroComponent2 from '@/components/SlideHeroComponent2.vue';
// import { UilVuejs } from "@iconscout/vue-unicons";
import Tailwind from "../assets/css/tailwind.css";
import AddStyle from "../assets/css/add-style.css";

import NavBarComponent from "@/components/NavBarComponent.vue";
import SponsorsComponent from "@/components/SponsorsComponent.vue";
import AboutComponent from "@/components/AboutComponent.vue";
import AboutCompanyComponent from "@/components/AboutCompanyComponent.vue";
import PricingComponent from "@/components/PricingComponent.vue";
import PricingHostingComponent from "@/components/PricingHostingComponent.vue";
import DataLineComponent from "@/components/DataLineComponent.vue";
import FooterComponent from "@/components/footerComponent.vue";
import StepTreatComponent from "@/components/StepTreatComponent.vue";
import AboutCompanyComponentNext from "@/components/AboutCompanyComponentNext.vue";
import BackToTopComponent from "@/components/BackToTopComponent.vue";
import TestimonialComponent from "@/components/TestimonialComponent.vue";
import CookiePopupComponent from "@/components/CookiePopupComponent.vue";
import SlideHeroComponent2 from "@/components/SlideHeroComponent2.vue";
import VideoPlayComponent from "@/components/VideoPlayComponent.vue";
import ProductCardComponent from "@/components/ProductCardComponent.vue";
import GrilleHostingComptoir from "@/components/GrilleHostingComptoir.vue";
export default {
  name: "HomeView",
  components: {
    // UisStar,
    // UilVuejs,
    Tailwind,
    AddStyle,
    NavBarComponent,
    SponsorsComponent,
    AboutComponent,
    AboutCompanyComponent,
    PricingComponent,
    PricingHostingComponent,
    DataLineComponent,
    FooterComponent,
    StepTreatComponent,
    AboutCompanyComponentNext,
    BackToTopComponent,
    TestimonialComponent,
    CookiePopupComponent,
    VideoPlayComponent,
    ProductCardComponent,
    GrilleHostingComptoir,
    SlideHeroComponent2,
  },
  data() {
    return {
      isOpen: false,
     
    };
  },
};
</script>

<style scoped>
.perso {
  width: 100%;
  margin: auto;
  margin-top: 50px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: top;
}

@media (min-width: 1024px) {
  .perso {
    width: 80%;
    margin: auto;
    margin-top: 50px;
    margin-bottom: 50px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: top;
  }

  .description {
    width: 50%;
    margin-top: 40px;
  }
}

.title {
  font-weight: 900;
}

.description {
  width: 90%;
  margin-top: 40px;
}

* {
  box-sizing: border-box;
}

h1,
h2,
h3,
p {
  margin: 0;
  padding: 0;
}

h1,
h2,
h3 {
  font-weight: 500;
}

/* Box List */
.box--list {
  /* padding: 60px 70px 100px; */
  max-width: 635px;
  margin-bottom: 30px;
}

@media (max-width: 870px) {
  .box--list {
    margin-bottom: 0;
    padding-bottom: 0;
  }
}

.box--list__header {
  display: flex;
  flex-direction: row;
  align-items: left;
  justify-content: space-between;
}

.box--list__header-title {
  font-size: 18px;
  text-align: center;
  /* line-height: 20px; */
}

.box--list__item {
  padding-top: 15px;
}

.box--list__item:first-child {
  border-top-width: 0;
}

.box--list__title {
  margin-bottom: 6px;
  font-size: 16px;
  /* color: #0d3460; */
}

.box--list__description {
  font-size: 14px;
  line-height: 26px;
  text-align: justify;
  font-weight: 500;
}

/* Generic Box */
.box {
  border-radius: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (max-width: 870px) {
  .box {
    border-radius: 0;
    max-width: 100%;
    box-shadow: none;
  }
}
.perso {
  padding-top: 50px;
  padding-bottom: 15px;
}

.w-5\/6 {
  width: 83.333333%;
}
</style>
